/**
 * Component for our Report showing all Return Reasons
 * grouped by Variant-Count for recent Returns.
 * 
 * @component
 */

import React from "react";
import Report from "../Report";

const columns = [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "Variant Name",
    dataIndex: "variantName",
    key: "variantName"
  },
  {
    title: "SKU",
    dataIndex: "sku",
    key:"sku"
  },
  {
    title: "Reason",
    dataIndex: "returnReason",
    key:"returnReason"
  },
  {
    title: "Count",
    dataIndex: "variantCount",
    key: "variantCount"
  },
];

const exportHeaders = [
  {
    label: "Product Name",
    value: "productName",
  },
  {
    label: "Variant Name",
    value: "variantName",
  },
  {
    label: "SKU",
    value: "sku",
  },
  {
    label: "Reason",
    value: "returnReason",
  },
  {
    label: "Count",
    value: "variantCount",
  },
];

class ByVariant extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Report
        url="/api/reports/reasons/by-variant"
        title="Top Reasons by Variant"
        tooltip="This report shows how many times a variant was returned for the same reason within the selected date range."
        columns={columns}
        reportName="reasons-by-variant"
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default ByVariant;
